import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { isArray, isNull } from 'lodash';
import { Tooltip, IconButton } from '@material-ui/core';
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import { Info } from '@material-ui/icons';

import api from '~/services/api';
import { TimeWeek, SelectDataInTable, SelectDataInTableWithSearch } from '~/componentslocal';
import { Select, Input } from '~/components/Form';
import { t } from '~/helpers';
import {
  changeDaysWeek,
  changeBlockDates,
  changeCounties,
  changeCountiesProduts,
} from '~/store/modules/unityRegistration/actions';

import * as S from './styles';


const theme = createMuiTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: "1.4rem",
      },
    }
  }
});


function Parametros({ dataUnity }) {
  const [items, setItems] = useState([]);
  const [isBreak, setIsBreak] = useState(true);
  const [transaction, setTransaction] = useState(true);

  const [disableLapi, setDisableLapi] = useState(false)
  const [disableLapt, setDisableLapt] = useState(false)

  const [dataUnidade, setDataUnidade] = useState(dataUnity || {
    usua_login_rep_unidade_lapt: '',
    usua_login_rep_unidade_lapi: ''
  })

  const dispatch = useDispatch();

  const userInfo = useSelector(state => state.user)

  const { daysWeek, blockDates, counties, countiesProduts } = useSelector(
    (state) => state.unityRegistration
  );

  const schemaMunicipioProduto = useMemo(
    () => ({
      muni_codigo: Yup.number()
        .nullable()
        .required(t('s.geral.validacao.campoobrigatorio')),
      prod_codigo: Yup.number()
        .nullable()
        .required(t('s.geral.validacao.campoobrigatorio')),
    }),
    []
  );

  const fieldsMunicipioProduto = useMemo(
    () => [
      {
        id: "muni_codigo",
        type: 'autocomplete',
        label: "Município",
        title: "Município",

        option: {
          label: "muni_nome_str",
          url: "municipio/municipiolista",
          unique: "muni_codigo",
          hiddens: [{ name: 'muni_nome' }],
        },
      },
      {
        id: "prod_codigo",
        type: 'autocomplete',
        label: "Combustível",
        title: "Combustível",
        option: {
          label: "prod_descricao",
          url: "produtos",
          unique: "prod_codigo",
          hiddens: [{ name: 'prod_descricao' }],
        },
      },
    ],
    []
  );

  const cellsmunicipioproduto = useMemo(
    () => [
      { id: 'muni_codigo', label: 'Código Município' },
      { id: 'muni_nome', label: 'Município' },
      // { id: 'prod_codigo', label: 'Código Combustível' },
      { id: 'prod_descricao', label: 'Combustível' },
      { id: 'perfil_desc', label: 'Cadastrado por' }
    ],
    []
  );


  useEffect(() => {

    if (!isNull(dataUnidade.usua_login_rep_unidade_lapt) && dataUnidade.usua_login_rep_unidade_lapt_perf_tipo != 1 && dataUnidade.unid_tipo_transacao != 0 && (userInfo.profile.perf_tipo == 1 || dataUnidade.usua_login_rep_unidade_lapt_perf_tipo < userInfo.profile.perf_tipo)) {
      setDisableLapt(true)
    }
    if (!isNull(dataUnidade.usua_login_rep_unidade_lapi) && dataUnidade.usua_login_rep_unidade_lapi_perf_tipo != 1 && dataUnidade.unid_tipo_intervalo != 0 && (userInfo.profile.perf_tipo == 1 || dataUnidade.usua_login_rep_unidade_lapi_perf_tipo < userInfo.profile.perf_tipo)) {
      setDisableLapi(true)
    }
  }, [dataUnidade, userInfo])

  const cells = useMemo(
    () => [
      { id: 'muni_codigo', label: 'Código' },
      { id: 'muni_nome', label: 'Município' },
      { id: 'perfil_desc', label: 'Cadastrado por' }
    ],
    []
  );

  const handleChangeDaysWeek = useCallback((value) => {
    // dispatch(changeDaysWeek(value.filter((day) => !day.error)));
    dispatch(changeDaysWeek(value));
  }, []);

  const handleChangeBlockDates = useCallback((value) => {
    dispatch(changeBlockDates(value));
  }, []);

  const handleChangeCounties = useCallback((value) => {
    dispatch(changeCounties(value));
  }, []);

  const handleChangeCountiesProduts = useCallback((value) => {
    dispatch(changeCountiesProduts(value));
  }, []);


  const handleGetAPICounties = useCallback(async () => {
    try {
      const { data } = await api.get('municipio', {
        params: { pagesize: 999, pesquisalista: true },
      });

      setItems(
        data.items.map((item) => ({
          ...item,
          id: item.muni_codigo,
          label: item.muni_nome,
          value: item.muni_codigo,
        }))
      );
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  useEffect(() => {
    handleGetAPICounties();
  }, []);

  return (
    <S.Container>
      <TimeWeek
        title="Abastecer somente nos dias da semana"
        data={daysWeek}
        onChangeDays={handleChangeDaysWeek}
        desktop={4}
        tablet={3}
        mobile={1}
        userPerfil={userInfo.profile}
      />

      <SelectDataInTable
        date
        disablePreviousDate
        size="small"
        title="Bloquear abastecimento nas datas"
        onChanged={handleChangeBlockDates}
        initials={blockDates}
        userPerfil={userInfo.profile}
      />

      <S.Grid>
        <fieldset>
          {(dataUnidade.usua_login_rep_unidade_lapt && dataUnidade.unid_tipo_transacao != 0) &&
            <MuiThemeProvider theme={theme}>
              <S.infoWrapper>
                <S.iconWrapper>
                  <Tooltip placement="left-end"
                    title={`Alterado por: ${dataUnidade.usua_login_rep_unidade_lapt} - ${dataUnidade.usua_login_rep_unidade_lapt_perf_descricao}`}>
                    <IconButton style={{ padding: 2 }}>
                      <Info style={{ height: '20px', width: '20px' }} color="secondary" />
                    </IconButton>
                  </Tooltip>
                </S.iconWrapper>

              </S.infoWrapper>
            </MuiThemeProvider>
          }


          <legend className="__legend">
            Limitar abastecimento por transação
          </legend>

          <Select
            name="unid_tipo_transacao"
            label="Tipo"
            options={[
              { value: 0, label: 'Não há controle' },
              { value: 1, label: 'Controle por dia' },
              { value: 2, label: 'Controle por semana' },
              { value: 3, label: 'Controle por mês' },
            ]}
            getValue={(value) => setIsBreak(value === 0)}
            disabled={disableLapt}
          />

          <Input
            name="unid_transacoes"
            label="Número"
            type="number"
            disabled={isBreak || disableLapt}
          />
        </fieldset>

        <fieldset>

          {(dataUnidade.usua_login_rep_unidade_lapi && dataUnidade.unid_tipo_intervalo) &&
            <MuiThemeProvider theme={theme}>
              <S.infoWrapper>
                <S.iconWrapper>
                  <Tooltip placement="left-end"
                    title={`Alterado por: ${dataUnidade.usua_login_rep_unidade_lapi} - ${dataUnidade.usua_login_rep_unidade_lapi_perf_descricao}`}>
                    <IconButton style={{ padding: 2 }}>
                      <Info style={{ height: '20px', width: '20px' }} color="secondary" />
                    </IconButton>
                  </Tooltip>
                </S.iconWrapper>

              </S.infoWrapper>
            </MuiThemeProvider>
          }


          <legend className="__legend">
            Limitar abastecimento por intervalo
          </legend>

          <Select
            name="unid_tipo_intervalo"
            label="Tipo"
            options={[
              { value: 0, label: 'Não há controle' },
              { value: 1, label: 'Tempo em horas' },
              { value: 2, label: 'Quilometragem' },
            ]}
            getValue={(value) => setTransaction(value === 0)}
            disabled={disableLapi}
          />

          <Input
            name="unid_intervalo"
            label="Número"
            type="number"
            disabled={transaction || disableLapi}

          />
        </fieldset>
      </S.Grid>

      <SelectDataInTable
        title="Município liberado para abastecimento"
        label="Município"
        unique="muni_codigo"
        maxWidth="xs"
        size="small"
        cells={cells}
        items={items}
        initials={counties}
        onChanged={handleChangeCounties}
        userPerfil={userInfo.profile}
      />

      <SelectDataInTableWithSearch
        title="Bloqueio Tipo Combustível no Município "
        label="Município"
        unique={["muni_codigo", "prod_codigo"]}
        maxWidth="xs"
        schema={schemaMunicipioProduto}
        search={true}
        size="small"
        cells={cellsmunicipioproduto}
        // items={items}
        fields={fieldsMunicipioProduto}
        initials={countiesProduts}
        onChanged={handleChangeCountiesProduts}
        userPerfil={userInfo.profile}
      />


    </S.Container>
  );
}

export default Parametros;
